export default __webpack_public_path__ + "static/media/logo-recognition.beda8922.png";